export const QINIU_CDN = 'http://t0fbw4zsz.hn-bkt.clouddn.com/'

export const ENTRY_URL = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx37c134b1e3eb0911&redirect_uri=http://xinshengdianzi.cn&response_type=code&scope=snsapi_base&state=YKH1585102108855#wechat_redirect'

// 写一个格式化时间的函数



// WEBPACK FOOTER //
// ./src/config/index.js